import classNames from 'classnames'
import styled from 'styled-components'

import { useRoute } from '../../../hooks/useRoute'
import GiftIcon from '../Icons/GiftIcon'

interface Props {
    className?: string
}

const Styles = styled.div`
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;

    button {
        min-height: unset;
        padding: 3px 3px;
    }
`

const message = 'Earn $25 discount for every new signed-up user'

export const ReferralBanner = ({ className }: Props) => {
    const { navReferral } = useRoute()

    return (
        <Styles className={classNames('bg-primary text-white border-b gap-2', className)}>
            <GiftIcon/>
            <span>{message}</span>
            <button onClick={navReferral}><span className='text-2xl'>&rarr;</span></button>
        </Styles>
    )
}
